import React from "react";
import "./AvisContainer.scss";

function AvisContainer() {
  return (
    <div className="container-main">
      <div className="title-container">
        <h2 data-aos="fade-down" data-aos-duration="1000" data-aos-offset="200">
          Avis
        </h2>
      </div>

      <div
        className="figures-wrapper"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-offset="200"
      >
        <figure
          className="avis-card"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-offset="200"
        >
          <div className="svg-wrapper">
            <svg viewBox="0 0 448 512">
              <path d="M0 216C0 149.7 53.7 96 120 96l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32 0-32 0-72zm256 0c0-66.3 53.7-120 120-120l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32 0-32 0-72z" />
            </svg>
          </div>
          <figcaption className="avis-description">
            <p className="avis-text">
              Très professionnel dans l’installation et le suivi de notre
              piscine.
              <br />
              <br />
              Les matériaux sont d’une excellente qualité.
              <br />
              <br />
              Nous sommes ravis !
            </p>
          </figcaption>
        </figure>
        <figure className="avis-card">
          <div className="svg-wrapper">
            <svg viewBox="0 0 448 512">
              <path d="M0 216C0 149.7 53.7 96 120 96l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32 0-32 0-72zm256 0c0-66.3 53.7-120 120-120l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32 0-32 0-72z" />
            </svg>
          </div>
          <figcaption className="avis-description">
            <p className="avis-text">
              Entreprise très réactive qui m’a bien accompagné tout au long de
              mon projet.
              <br />
              <br />
              Le résultat correspond exactement à ce que nous avions imaginé.
              <br />
              <br />
              Toujours à l’écoute de mes demandes et le SAV également pour
              m’apporter les explications nécessaires pour une bonne utilisation
              des équipements.
            </p>
          </figcaption>
        </figure>
        <figure
          className="avis-card"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-offset="200"
        >
          <div className="svg-wrapper">
            <svg viewBox="0 0 448 512">
              <path d="M0 216C0 149.7 53.7 96 120 96l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32 0-32 0-72zm256 0c0-66.3 53.7-120 120-120l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32 0-32 0-72z" />
            </svg>
          </div>
          <figcaption className="avis-description">
            <p className="avis-text">
              Je recommande SBHM, tout s'est très bien passé du début à la fin.
              <br />
              <br />
              Toute l'équipe est disponible et à l'écoute.
              <br />
              <br />
              N'hésitez pas !
            </p>
          </figcaption>
        </figure>
      </div>

      <div className="background-bar"></div>
      <div className="background-bar-2"></div>
    </div>
  );
}
export default AvisContainer;
